import Flickity from 'flickity';


const flickityClass = 'f-carousel';
const baseClass = 'posts-carousel';
const cellClass = `${baseClass}__cell`;
const slideClass = `${baseClass}__slide`;


const PostCarousels = (() => {
	const c = {
		instances: [],
		cellsPerSlide: 1,
	}

	c.init = function() {
		const uninstantiated = Array.from(document.querySelectorAll(`.${flickityClass}.${baseClass}`));
		if (!uninstantiated.length) {
			return;
		}

		c.cellsPerSlide = calcCellsPerSlide();

		uninstantiated.forEach(root => {
			const instance = c.initCarousel(root);
			if (instance) {
				c.instances.push(instance);
			}
		});


		window.addEventListener('load', c.resizeInstances, {once: true});
		window.addEventListener('DOMContentLoaded', c.resizeInstances, {once: true});

		//TODO: debounce this
		window.addEventListener('resize', c.handleWindowResize);
	}


	c.initCarousel = function(root) {
		const slides = organiseSlides(root, c.cellsPerSlide);

		const hasMultipleSlides = slides.length > 1;

		const config = {
			cellSelector: `.${slideClass}`,
			groupCells: false,
			pageDots: hasMultipleSlides,
			accessibility: true,
			arrowShape: 'M60.4,100L16.2,52.5c-1.8-1.9-1.7-4.9,0.1-6.8L60.5,0l7.1,6.8L26.6,49.2l41,44.1L60.4,100z',
			prevNextButtons: hasMultipleSlides,
			cellAlign: 'left',
			adaptiveHeight: false,
			draggable: hasMultipleSlides,
			wrapAround: true,
			on: {
				staticClick: function(e) {
					// re-enable swup for this link by the time it's event
					// is received by jquery
					if (e.target.hasAttribute('data-no-swup')) {
						e.target.removeAttribute('data-no-swup');
					}
				},
			},
		}

		const instance = new Flickity(root, config);

		return instance;
	}

	c.handleWindowResize = function(e) {
		const newCellsPerSlide = calcCellsPerSlide();
		if (newCellsPerSlide !== c.cellsPerSlide) {
			c.refreshInstances();
		}
	}

	c.refreshInstances = function() {
		c.cellsPerSlide = calcCellsPerSlide();

		c.instances = c.instances.map(oldInstance => {
			const rootElem = oldInstance.element;
			oldInstance.destroy();

			const newInstance = c.initCarousel(rootElem);

			return newInstance;
		})
		.filter(instance => !!instance);
	}

	c.resizeInstances = function() {
		c.instances.forEach(instance => {
			instance.resize();
		})
	}


	return c;
})();


function organiseSlides(carouselRoot, cellsPerSlide) {
	if (!carouselRoot) {
		return;
	}

	const cells = Array.from(carouselRoot.querySelectorAll(`.${cellClass}`))

	// generate new slides and populate them with cells
	const cellGroups = groupCells(cells, cellsPerSlide);
	const slides = cellGroups.map(group => {
		const slide = makeSlide();
		slide.append(...group);
		// slide.style.setProperty('--cell-count', group.length);
		slide.setAttribute('data-cell-count', group.length);
		return slide;
	});

	// remove existing slides
	const existingSlides = Array.from(carouselRoot.querySelectorAll(`.${slideClass}`));
	existingSlides.forEach(slide => {
		slide.remove();
	})

	// append new slides to carousel
	carouselRoot.append(...slides);
	// carouselRoot.style.setProperty('--cells-per-slide', cellsPerSlide);
	carouselRoot.setAttribute('data-cells-per-slide', cellsPerSlide);

	return slides;
}

function makeSlide() {
	const slide = document.createElement('div');
	slide.classList.add(slideClass);

	return slide;
}

function calcCellsPerSlide() {
	const queries = [
		{query: '(max-width: 680px)', cells: 1},
		{query: '(max-width: 1200px)', cells: 2},
	];

	for (let i = 0; i < queries.length; i++) {
		const {query, cells} = queries[i];
		if (window.matchMedia(query).matches) {
			return cells;
		}
	}

	return 3; // largest
}

/**
 *
 * @param {Array} cells
 * @param {int} perGroup
 */
function groupCells(cells, perGroup) {

	if (!cells.length) {
		return [];
	}

	const numGroups = Math.ceil(cells.length / perGroup);

	const groups = Array
		.from({length: numGroups})
		.map((value, index) => {
			const start = index * perGroup;
			const end = start + perGroup;

			return cells.slice(start, end);
		})


	return groups;
}

export default PostCarousels;



// WEBPACK FOOTER //
// ./scripts/modules/post-carousels.js